import * as Sentry from '@sentry/react';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import './index.css';
import { logAndThrowError } from '@liquidbudget/common';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://ae03f8254bcf00080165ecd7b8210720@o4509316612620288.ingest.us.sentry.io/4509317021564929',
  });
}

const root = document.getElementById('root');

if (!root) {
  logAndThrowError('No root element found');
}

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

window.addEventListener('vite:preloadError', () => {
  setTimeout(() => {
    window.location.reload();
  }, 2000);
});
